/*
 * Faithful port of the AJAX remove-from-cart handler in resources/views/functions.blade.php
 * ($('.cart-remove-item').on('click', ...) POST to /deletecart, then location.reload()).
 * Shopify's native equivalent is POSTing quantity: 0 for the line item's key to /cart/change.js.
 * Shared by the cart page (main-cart.liquid) and the header mini-cart (cart-drawer.liquid).
 */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-remove-item[data-line-item-key]');
    if (!btn) return;
    e.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: btn.dataset.lineItemKey, quantity: 0 })
    }).then(function () {
      window.location.reload();
    });
  });
})();

/*
 * Port of AddToCart() in functions.blade.php. Laravel POSTs to /addcart and then rebuilds the
 * mini-cart in place - it never leaves the page. Shopify's {% form 'product' %} instead does a
 * full POST to /cart/add and redirects to /cart, which is a different experience, so the submit
 * is intercepted and sent to /cart/add.js followed by a redraw of .cart_list / .cart-count /
 * .totalprice (the same classes and markup Laravel's handler builds).
 *
 * "Buy Now" is deliberately left alone: it carries name="checkout", which Shopify uses to send
 * the form straight to checkout, and Laravel's BuyNow() behaves the same way.
 */
(function () {
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    // Indian grouping: last 3 digits, then pairs (matches the store's Rs. 1,23,456.00 format).
    var n = parts[0];
    var last3 = n.slice(-3);
    var rest = n.slice(0, -3);
    if (rest) last3 = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
    return 'Rs. ' + last3 + '.' + parts[1];
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function redrawMiniCart(cart) {
    var list = document.querySelector('.cart_list');
    if (list) {
      if (cart.item_count > 0) {
        list.innerHTML = cart.items.map(function (item) {
          var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_188x$1$2') : '';
          return '<div class="products"><div class="product product-cart">' +
            '<div class="product-detail"><a href="' + item.url + '" class="product-name">' +
            escapeHtml(item.product_title) + '</a>' +
            '<div class="price-box"><span class="product-quantity">' + item.quantity + '</span>' +
            '<span class="product-price">' + formatMoney(item.final_price) + '</span></div></div>' +
            '<figure class="product-media"><a href="' + item.url + '">' +
            '<img src="' + img + '" alt="' + escapeHtml(item.product_title) + '" height="84" width="94" style="height:84px;width:94px;"></a></figure>' +
            '<button class="btn btn-link btn-close cart-remove-item" aria-label="Remove" data-line-item-key="' + item.key + '">' +
            '<i class="fas fa-times"></i></button></div></div>';
        }).join('');
      } else {
        list.innerHTML = '<p>Cart Is empty</p>';
      }
    }
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
    document.querySelectorAll('.totalprice').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
  }

  /*
   * Why this has to be AJAX, and cannot be a plain form submit:
   *
   * theme-vendor-main.js (the Wolmart demo script) binds
   *     $body.on("click", ".product .btn-cart, .product-single .btn-cart", e => {
   *         e.preventDefault(); Wolmart.Minipopup.open({...})
   *     })
   * It cancels the default action and opens a decorative "added to cart" popup without
   * talking to any server. That is why clicking a card - or the product page button - showed
   * a success popup while the cart stayed empty: the navigation/submit was cancelled and
   * nothing was ever sent. preventDefault does not stop other listeners, so the real add is
   * performed here and the mini-cart is redrawn from Shopify's own /cart.js.
   */
  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) {
          alert(res.data.description || res.data.message || 'Product Not added to cart');
          return null;
        }
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) { if (cart) redrawMiniCart(cart); return cart; })
      .catch(function () { alert('Product Not added to cart'); return null; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-variant-id]');
    if (!btn) return;
    if (!btn.matches('.btn-cart, .add_to_cart, .btn-buy-now')) return;

    e.preventDefault();
    if (btn.dataset.cartBusy === '1') return;
    btn.dataset.cartBusy = '1';

    // Quantity only exists on the product page; cards always add one.
    var input = document.getElementById('product-quantity-input');
    var qty = input ? parseInt(input.value, 10) : 1;
    if (isNaN(qty) || qty < 1) qty = 1;

    var buyNow = btn.classList.contains('btn-buy-now');
    addToCart(btn.dataset.variantId, qty).then(function (cart) {
      if (cart && buyNow) window.location.href = '/checkout';
    }).then(function () { btn.dataset.cartBusy = '0'; });
  });

  window.redrawMiniCart = redrawMiniCart;
})();
